// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2qppO","footer":"ModalError_footer__37oE_"};